const methods = {
  showToast(options) {
    this.$root.$emit('acv::showToastMessage', options);
  },
  showErrorToast(message, options = {}) {
    this.showToast({
      header: 'There was a problem.',
      severity: 'error',
      message,
      ...options,
    });
  },
  showSuccessToast(message, options = {}) {
    this.showToast({
      header: 'Success.',
      severity: 'success',
      message,
      ...options,
    });
  },
  showInfoToast(message, options = {}) {
    this.showToast({
      severity: 'info',
      message,
      ...options,
    });
  },
  showWarningToast(message, options = {}) {
    this.showToast({
      header: 'Alert.',
      severity: 'warning',
      message,
      ...options,
    });
  },
  clearToastMessageById(id) {
    this.$root.$emit('acv::clearToastMessageById', id);
  },
};

export default {
  methods,
};
